import {Typography} from '@mui/material';
import {useState} from 'react';
import ArrDatePicker, {
  Condition,
} from '../../../components/common/arr-date-picker/ArrDatePicker';
import dayjs from 'dayjs';

const DateTimePicker = () => {
  const [dateValue, setDateValue] = useState<
    string | [] | [string | undefined, string | undefined]
  >('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [operators, setOperators] = useState<string[] | undefined>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [condition, setCondition] = useState<Condition | undefined>();
  const handleChange = (
    value: string | [] | [string | undefined, string | undefined],
    operators: string[] | undefined,
    condition: Condition | undefined
  ) => {
    setDateValue(value);
    setOperators(operators);
    setCondition(condition);
  };

  const onRangeChange = (start: string, end: string) => {
    setStartDate(start);
    setEndDate(end);
  };

  const minDateTime = dayjs('2025-10-20T02:00');
  const maxDateTime = dayjs('2025-10-29T05:30');

  return (
    <div>
      <Typography>{dateValue}</Typography>
      <Typography>
        {startDate} - {endDate}
      </Typography>

      <Typography>Date-Time Range Picker</Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-range-picker"
        label="Date Time Range Picker"
        placeholder="YYYY/MM/DD HH:mm - YYYY/MM/DD HH:mm"
        onRangeChange={onRangeChange}
        applyEnable={true}
        mode="date-time"
        dateFormat="YYYY/MM/DD HH:mm:ss"
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Date-Time Picker with minDate and maxDate </Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-picker"
        label="Date-Time Picker"
        placeholder="YYYY/MM/DD HH:mm:ss"
        dateFormat="YYYY/MM/DD HH:mm:ss"
        onChange={handleChange}
        applyEnable={true}
        mode="date-time"
        ampm={false}
        minDateTime={minDateTime}
        maxDateTime={maxDateTime}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Date-Time Picker with Clear button</Typography>
      <ArrDatePicker
        type="date-picker"
        dataTestId="demo-component"
        label="Date-Time Picker"
        placeholder="YYYY/MM/DD HH:mm:ss"
        dateFormat="YYYY/MM/DD HH:mm:ss"
        onChange={handleChange}
        applyEnable={true}
        mode="date-time"
        ampm={false}
        shouldShowClearButton={true}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Date-Time Picker with Initial value , required </Typography>
      <ArrDatePicker
        type="date-picker"
        dataTestId="demo-component"
        label="Date-Time Picker"
        placeholder="YYYY/MM/DD HH:mm:ss"
        dateFormat="YYYY/MM/DD HH:mm:ss"
        onChange={handleChange}
        applyEnable={true}
        initialStartDate="2022/02/02 10:10:00"
        required={true}
        mode="date-time"
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Disabled Date-Time Picker</Typography>
      <ArrDatePicker
        type="date-picker"
        dataTestId="demo-component"
        label="Date-Time Picker"
        initialStartDate="2022/02/02 10:10:00"
        mode="date-time"
        disabled={true}
        dateFormat="YYYY/MM/DD HH:mm:ss"
      />
    </div>
  );
};

export default DateTimePicker;
